import api from "./api";
import { ApiResponse } from "../types";

export interface Notificacao {
  id: string;
  tipo: string;
  titulo?: string | null;
  mensagem?: string | null;
  link?: string | null;
  payloadJson?: string | null;
  lidaEm?: string | null;
  criadaEm: string;
}

export interface NotificacoesPage {
  itens: Notificacao[];
  total: number;
  totalNaoLidas: number;
  page: number;
  pageSize: number;
}

export const notificacaoService = {
  /** Contador leve de não lidas — usado pelo polling. */
  async contagem(): Promise<number> {
    const r = await api.get<ApiResponse<{ naoLidas: number }>>(
      "/notificacoes/contagem",
    );
    return r.data.data?.naoLidas ?? 0;
  },

  /** Lista paginada das notificações do usuário logado. */
  async listar(page = 1, pageSize = 15): Promise<NotificacoesPage> {
    const r = await api.get<ApiResponse<NotificacoesPage>>(
      `/notificacoes?page=${page}&pageSize=${pageSize}`,
    );
    if (!r.data.data) {
      throw new Error(r.data.message || "Erro ao listar notificações");
    }
    return r.data.data;
  },

  async marcarLida(id: string): Promise<void> {
    await api.post(`/notificacoes/${id}/marcar-lida`, {});
  },

  async marcarTodasLidas(): Promise<void> {
    await api.post(`/notificacoes/marcar-todas-lidas`, {});
  },
};

export default notificacaoService;
